<template>
  <mtd-dropdown style="padding: 0 5px" trigger="click" placement="bottom">
    <mtd-popover trigger="hover">
      <div class="time">
        <span class="time-text">{{
          $getText(`b_fe_jiemo_pc_${region.toLocaleLowerCase()}`) +
          " " +
          titleTime
        }}</span>
        <mtd-icon name="mtdicon-down-thick" class="time-icon" />
      </div>
      <template #content>
        <div>
          {{
            $getText(`b_fe_jiemo_pc_${region.toLocaleLowerCase()}`) +
            " " +
            titleTime
          }}
        </div>
      </template>
    </mtd-popover>
    <template #dropdown>
      <mtd-dropdown-menu>
        <mtd-dropdown-menu-item
          v-for="item in regionList"
          :key="item"
          :command="item"
          @click="onCommand(item)"
        >
          <div :class="{ selected: item === region, 'dropdown-item': true }">
            <span class="label">
              {{
                $getText(`b_fe_jiemo_pc_${region.toLocaleLowerCase()}`)
              }}</span
            >
            <mtd-icon
              v-if="item === region"
              name="mtdicon-check"
              class="check"
            ></mtd-icon>
          </div>
        </mtd-dropdown-menu-item>
      </mtd-dropdown-menu>
    </template>
  </mtd-dropdown>
</template>
<script>
import { MDateTime, MCity } from "@sailor/i18n-vue";
import { getCacheLocale } from "@sailor/i18n-shared";

export default {
  data() {
    // const initRegion = localStorage.getItem("i18nRegion") || "SA";
    // const initCity = MCity.getCapitalCityIdByRegion(initRegion);
    const initLocale = getCacheLocale() || "en";
    const initTime = new Date().getTime();
    return {
      region: "",
      regionList: ["SA"],
      cityId: "",
      locale: initLocale,
      time: initTime,
    };
  },
  computed: {
    titleTime() {
      return MDateTime.formatByCityId(
        this.cityId,
        this.time,
        -1,
        2,
        this.locale
      );
    },
    title() {
      return this.$getText(`b_fe_jiemo_pc_${this.region.toLocaleLowerCase()}`);
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    setInterval(() => {
      this.time = new Date().getTime();
    }, 1000);
  },
  methods: {
    initData() {
      const region = localStorage.getItem("i18nRegion") || "SA";
      try {
        localStorage.setItem("i18nRegion", region);
      } catch (error) {
        console.error("Failed to set i18nRegion:", error);
      }
      const initCity = MCity.getCapitalCityIdByRegion(region);
      this.region = region;
      this.cityId = initCity;
    },
    onCommand(region) {
      localStorage.setItem("i18nRegion", region);
      window.location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.time {
  color: #111925;
  cursor: pointer;
  margin-inline-end: 24px;

  .time-text {
    margin-inline-end: 4px;
  }

  .time-icon {
    font-size: 18px;
    vertical-align: middle;
  }
}

.time-dropdown {
  width: 200px;

  .dropdown-item {
    display: flex;
    align-items: center;

    .label {
      flex: 1;
    }
  }
}
.selected {
  color: #00b85c;
  font-weight: 700;
}
.check {
  margin-left: 10px;
}
</style>
